var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M1.668 10.734V9.267c0-.866.708-1.583 1.583-1.583 1.509 0 2.125-1.067 1.367-2.375a1.583 1.583 0 0 1 .583-2.158l1.442-.825c.658-.392 1.508-.159 1.9.5l.092.158c.75 1.308 1.983 1.308 2.741 0l.092-.158c.392-.659 1.242-.892 1.9-.5l1.442.825a1.583 1.583 0 0 1 .583 2.158c-.758 1.308-.142 2.375 1.367 2.375.866 0 1.583.708 1.583 1.583v1.467c0 .867-.708 1.583-1.583 1.583-1.509 0-2.125 1.067-1.367 2.375a1.58 1.58 0 0 1-.583 2.159l-1.442.825c-.658.391-1.508.158-1.9-.5l-.092-.159c-.75-1.308-1.983-1.308-2.741 0l-.092.159c-.392.658-1.242.891-1.9.5l-1.442-.825a1.582 1.582 0 0 1-.583-2.159c.758-1.308.142-2.375-1.367-2.375a1.588 1.588 0 0 1-1.583-1.583Z"
  })));
};
export default SvgSettings;